import React from 'react';
import { useNavigate } from 'react-router-dom';

const UseCasesHeroSection = () => {
  const navigate = useNavigate();

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        backgroundColor: '#242423',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className="px-4 md:px-6 lg:px-8"
    >
      {/* Background Image Layer - Very Subtle */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/assets/images/Use_Cases-1770327502436.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          opacity: 0.12,
          zIndex: 0,
        }}
      />
      {/* Gradient Fade Overlay - Aggressive Fade */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(to bottom, transparent 0%, rgba(36, 36, 35, 0.4) 30%, rgba(36, 36, 35, 0.8) 60%, #242423 85%)',
          zIndex: 1,
        }}
      />
      {/* Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '64rem',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        {/* Badge */}
        <div
          style={{
            display: 'inline-block',
            color: '#F5CB5C',
            fontSize: '0.75rem',
            fontWeight: 'bold',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginBottom: '1.5rem',
          }}
        >
          USE CASES
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            fontWeight: 'bold',
            color: '#E8EDDF',
            marginBottom: '1.5rem',
            lineHeight: '1.1',
          }}
        >
          Sleeve Across Industries
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            color: '#9CA3AF',
            maxWidth: '48rem',
            margin: '0 auto 2rem',
            lineHeight: '1.6',
          }}
        >
          Each use case demonstrates how Sleeve solves a specific system-of-systems
          challenge—coordinating agents, legacy systems, and human operators across
          high-stakes, distributed industrial environments.
        </p>

        {/* Bullet Points */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            alignItems: 'flex-start',
            maxWidth: '36rem',
            margin: '0 auto 2.5rem',
            textAlign: 'left',
          }}
        >
          {[
            'Real-world orchestration patterns',
            'Multi-domain system integration',
            'Proven deployment architectures',
          ]?.map((item, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
              }}
            >
              <div
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: '#4FB3B8',
                  flexShrink: 0,
                }}
              />
              <span style={{ color: '#E8EDDF', fontSize: '1rem' }}>{item}</span>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          {/* Primary Button */}
          <button
            onClick={() => navigate('/contact')}
            style={{
              backgroundColor: '#4FB3B8',
              color: '#242423',
              padding: '0.875rem 2rem',
              borderRadius: '0.5rem',
              fontWeight: '600',
              fontSize: '1rem',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#3A9CA1';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#4FB3B8';
            }}
          >
            Discuss Your Use Case
          </button>

          {/* Secondary Button */}
          <button
            onClick={() => navigate('/product')}
            style={{
              backgroundColor: 'transparent',
              color: '#F5CB5C',
              padding: '0.875rem 2rem',
              borderRadius: '0.5rem',
              fontWeight: '600',
              fontSize: '1rem',
              border: '1px solid #3A3A38',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#F5CB5C';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = '#3A3A38';
            }}
          >
            Explore the Platform
          </button>
        </div>
      </div>
    </section>
  );
};

export default UseCasesHeroSection;